import { render } from "./WebSocketTest.vue?vue&type=template&id=4804f2f7&scoped=true"
import script from "./WebSocketTest.vue?vue&type=script&lang=js"
export * from "./WebSocketTest.vue?vue&type=script&lang=js"

import "./WebSocketTest.vue?vue&type=style&index=0&id=4804f2f7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4804f2f7"]])

export default __exports__